import { SpecialPrizesPresetsActionTypes } from "./actionTypes";

export const SpecialPrizesPresetsActionCreators = {
    getSubsidiaries: () => ({
        type: SpecialPrizesPresetsActionTypes.GET_SUBSIDIARIES
    }),

    getPresets: ({ page, top, search, subsidiaries, types, status, certified }) => ({
        type: SpecialPrizesPresetsActionTypes.GET_PRESETS,
        payload: {
            page,
            top,
            search,
            subsidiaries,
            types,
            status,
            certified
        }
    }),

    getPreset: presetID => ({
        type: SpecialPrizesPresetsActionTypes.GET_PRESET,
        payload: {
            presetID
        }
    }),

    addPreset: ({ prizes, base }) => ({
        type: SpecialPrizesPresetsActionTypes.ADD_PRESET,
        payload: {
            prizes,
            base
        }
    }),

    clearPreset: () => ({
        type: SpecialPrizesPresetsActionTypes.CLEAR_PRESET
    }),

    clearSubmitPreset: () => ({
        type: SpecialPrizesPresetsActionTypes.CLEAR_SUBMIT_PRESET
    }),

    certifiedPreset: (presetId, certified) => ({
        type: SpecialPrizesPresetsActionTypes.TOGGLE_CERTIFIED_PRESET,
        payload: {
            certified: certified,
            presetId: presetId
        }
    }),

    activatePreset: presetId => ({
        type: SpecialPrizesPresetsActionTypes.TOGGLE_PRESET_ACTIVE,
        payload: {
            active: true,
            presetId: presetId
        }
    }),

    deactivatePreset: presetId => ({
        type: SpecialPrizesPresetsActionTypes.TOGGLE_PRESET_ACTIVE,
        payload: {
            active: false,
            presetId: presetId
        }
    }),


};
